import React, { useEffect, useState } from "react";

/* 40px utility bar — company brand · user identity · search · LIVE · UTC clock · settings · sign-out.
   Per client feedback the COMPANY NAME and USER NAME live in the
   top frame on every terminal page. The bar nudged up by 4px to
   give the typography room to breathe.

   The search trigger fires the existing global ⌘K event so the
   command palette stays a single source of truth across the redesign
   and the legacy chrome that still ships behind the same shortcut. */

function useUtcClock() {
  const [clock, setClock] = useState(() => new Date().toUTCString().slice(17, 25));
  useEffect(() => {
    const id = setInterval(() => setClock(new Date().toUTCString().slice(17, 25)), 1000);
    return () => clearInterval(id);
  }, []);
  return clock;
}

/* Initials from a display name. Used in the user identity avatar
   as a deterministic fallback when there's no profile image. */
function initialsOf(name) {
  if (!name) return "U";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "U";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default function UtilBar({
  companyName,
  userName,
  userEmail,
  accountLabel,
  baseCurrency = "USD",
  onSignOut,
  onSettings,
  onCards,
}) {
  const clock = useUtcClock();

  const triggerCmdK = () => {
    const evt = new KeyboardEvent("keydown", {
      key: "k", metaKey: true, ctrlKey: true, bubbles: true,
    });
    window.dispatchEvent(evt);
  };

  /* Company name falls back to the generic wordmark only if no tenant
     name is known — the goal is that a real organization NEVER sees
     a generic brand in the top frame. */
  const brand = companyName && companyName.trim()
    ? companyName.toUpperCase()
    : "BLOX·TREASURY";
  const displayUser = userName || userEmail || "";

  return (
    <div className="term-util">
      <div className="term-brand" title={companyName || ""}>
        <span className="term-brand-name">{brand}</span>
        <span className="term-brand-tag">TREASURY TERMINAL</span>
      </div>

      <div className="term-util-meta">
        {accountLabel ? <>{accountLabel}<span className="sep">·</span></> : null}
        {baseCurrency} base
      </div>

      <div className="term-cmd-trigger" onClick={triggerCmdK} role="button" tabIndex={0}
           onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") triggerCmdK(); }}>
        <span aria-hidden="true">⌕</span>
        <span style={{ flex: 1 }}>Search counterparties, payments, channels…</span>
        <kbd>⌘K</kbd>
      </div>

      <div className="term-live"><span className="term-live-dot" />LIVE</div>
      <div className="term-util-meta">{clock} UTC</div>

      {displayUser && (
        <div className="term-user" title={userEmail || displayUser}>
          <span className="term-user-avatar">{initialsOf(userName || userEmail)}</span>
          <span className="term-user-name">{displayUser}</span>
        </div>
      )}

      {onCards && (
        <button className="term-util-btn" onClick={onCards} title="Company cards (ViaCarte)">Cards</button>
      )}
      <button className="term-util-btn" onClick={onSettings}>Settings</button>
      <button className="term-util-btn" onClick={onSignOut}>Sign out</button>
    </div>
  );
}
